import React, { FC } from 'react';

import { styled } from '@mui/system';
import { Box, Container, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

import Logo from '../../components/LogoSign';
import BackBtnComp from '../BackBtn';

interface AuthFrameProps {
  title?: string | React.ReactNode;
  children: React.ReactNode;
  handleBackBtnClick?: () => void;
  currentForm?: string;
  titleStyles?: SxProps<Theme>;
}

const StyledContainer = styled(Container)({
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

const StyledPaper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(4),
  borderRadius: 10,
  boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 10px'
}));

const AuthFrame: FC<AuthFrameProps> = ({
  title,
  titleStyles = {},
  children,
  handleBackBtnClick,
  currentForm = 'login'
}) => {
  const isSlimForm = ['login', 'forgot-password'].includes(currentForm);

  return (
    <StyledContainer maxWidth={isSlimForm ? 'xs' : 'sm'}>
      <StyledPaper sx={{ width: isSlimForm ? '100%' : '80%' }}>
        {['signup', 'sms', 'forgot-password'].includes(currentForm) &&
          !!handleBackBtnClick && (
          <Box display="flex" sx={{ width: '100%' }}>
            <BackBtnComp handleOnClick={handleBackBtnClick} />
          </Box>
          )}
        <Logo light clickable={false} />
        <Typography sx={{ my: 3, ...titleStyles }} variant="h5">
          {title}
        </Typography>
        {children}
      </StyledPaper>
    </StyledContainer>
  );
};

export default AuthFrame;
